// 9fbef606107a605d69c0edbcd8029e5d
import {
  FETCH_RECOMMENDATIONS_DATA,
  FETCH_RECOMMENDATIONS_DATA_MONETATE,
  FETCH_RECOMMENDATIONS_DATA_UNBXD,
  SEND_EVENTS_TO_MONETATE,
  FETCH_RECOMMENDATIONS_DATA_ADOBE,
  LOAD_RECOMMENDATIONS_DATA,
  UPDATE_RECOMMENDATIONS_DATA,
  OPEN_RECOMMENDATION_ORDER_MODAL,
  CLOSE_RECOMMENDATION_ORDER_MODAL,
  SET_RECOMMENDATION_LOADING_STATE,
  LOAD_RECOMMENDATIONS_ALL_DATA,
  LOAD_RECOMMENDATIONS_GIRL_DATA,
  LOAD_RECOMMENDATIONS_BOY_DATA,
  LOAD_RECOMMENDATIONS_BABY_DATA,
  LOAD_RECOMMENDATIONS_TODDLER_BOY_DATA,
  LOAD_RECOMMENDATIONS_TODDLER_GIRL_DATA,
  LOAD_RECOMMENDATIONS_LOADER,
  CLEAR_RECOMMENDATIONS_DATA,
} from './Recommendations.constants';

export const fetchRecommendationsData = (payload) => {
  return {
    type: FETCH_RECOMMENDATIONS_DATA,
    payload,
  };
};

export const fetchRecommendationsDataMonetate = (payload) => {
  return {
    type: FETCH_RECOMMENDATIONS_DATA_MONETATE,
    payload,
  };
};

export const fetchRecommendationsDataUnBxd = (payload) => {
  return {
    type: FETCH_RECOMMENDATIONS_DATA_UNBXD,
    payload,
  };
};

export const sendEventsToMonetate = (payload) => {
  return {
    type: SEND_EVENTS_TO_MONETATE,
    payload,
  };
};

export const fetchRecommendationsDataAdobe = (payload) => {
  return {
    type: FETCH_RECOMMENDATIONS_DATA_ADOBE,
    payload,
  };
};

export const loadRecommendationsData = (payload) => {
  return {
    type: LOAD_RECOMMENDATIONS_DATA,
    payload,
  };
};
export const loadRecommendationsLoader = (payload) => {
  return {
    type: LOAD_RECOMMENDATIONS_LOADER,
    payload,
  };
};
export const loadRecommendationsAllCategoryData = (payload) => {
  return {
    type: LOAD_RECOMMENDATIONS_ALL_DATA,
    payload,
  };
};
export const loadRecommendationsGirlCategoryData = (payload) => {
  return {
    type: LOAD_RECOMMENDATIONS_GIRL_DATA,
    payload,
  };
};
export const loadRecommendationsBoyCategoryData = (payload) => {
  return {
    type: LOAD_RECOMMENDATIONS_BOY_DATA,
    payload,
  };
};
export const loadRecommendationsBabyCategoryData = (payload) => {
  return {
    type: LOAD_RECOMMENDATIONS_BABY_DATA,
    payload,
  };
};
export const loadRecommendationsToddlerGirlCategoryData = (payload) => {
  return {
    type: LOAD_RECOMMENDATIONS_TODDLER_GIRL_DATA,
    payload,
  };
};
export const loadRecommendationsToddlerBoyCategoryData = (payload) => {
  return {
    type: LOAD_RECOMMENDATIONS_TODDLER_BOY_DATA,
    payload,
  };
};

export const updateRecommendationsLoading = (payload) => {
  return {
    type: UPDATE_RECOMMENDATIONS_DATA,
    payload,
  };
};

export const openRecommendationOrderModal = (payload) => {
  return {
    type: OPEN_RECOMMENDATION_ORDER_MODAL,
    payload,
  };
};

export const closeRecommendationOrderModal = (payload) => {
  return {
    type: CLOSE_RECOMMENDATION_ORDER_MODAL,
    payload,
  };
};

export const setRecommendationLoadingState = (payload) => {
  return {
    type: SET_RECOMMENDATION_LOADING_STATE,
    payload,
  };
};

export const clearRecommendationData = (payload) => {
  return {
    type: CLEAR_RECOMMENDATIONS_DATA,
    payload,
  };
};

export default {
  fetchRecommendationsData,
  loadRecommendationsData,
};
